import { render, staticRenderFns } from "./EditTeamLeaderFeedback.vue?vue&type=template&id=3874c2b8"
import script from "./EditTeamLeaderFeedback.vue?vue&type=script&lang=js"
export * from "./EditTeamLeaderFeedback.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports